<template>
    <div v-show="can.update.bookable_category">
        <button-secondary @click="open">
            <i class="fa fa-ellipsis-v mr-2"></i> Einstellungen
        </button-secondary>
        <portal to="modal" v-if="showModal">
            <modal @close="showModal = false">
                <template v-slot:header>Bearbeiten</template>

                <input-text v-model="bookableHoursBeforeDay" class="mb-8">
                    Buchung erst x Stunden vor dem Tag möglich
                    <template v-slot:helper>z.B. 0 - {{ category.name }} lassen sich nur am gleichen Tag buchen. 24 -
                        {{ category.name }} lassen sich einen Tag vorher buchen. Leer lassen um zu deaktivieren.
                    </template>
                </input-text>

                <input-text v-model="maxConcurrentBookingPerDay" class="mb-8" type="number" >
                    Max. erlaubte gleichzeitige Buchungen pro Benutzer / Tag
                    <template v-slot:helper>1 - Benutzer ist erlaubt nur max. 1 {{ category.name }} an dem gleichen Tag buchen. <br>0 -
                        {{ category.name }} kann beliebig gebucht werden, ohne Limit.
                    </template>
                </input-text>

                <loading v-show="loading"></loading>

                <div class="flex justify-end" v-show="!loading">
                    <button-primary @click="store">Speichern</button-primary>
                </div>
            </modal>
        </portal>
    </div>
</template>

<script>
import Modal from "../Modal.vue";
import InputText from "../UI/InputText.vue";
import ButtonPrimary from "../UI/ButtonPrimary.vue";
import Loading from "../UI/Loading.vue";
import ButtonSecondary from "../UI/ButtonSecondary.vue";

export default {
    name: "BookableCategoryEdit",

    components: {
        ButtonSecondary,
        Loading,
        ButtonPrimary,
        InputText,
        Modal
    },

    inject: ['can'],

    props: ['category'],

    data: () => ({
        showModal: false,
        bookableHoursBeforeDay: null,
        maxConcurrentBookingPerDay: null,
        loading: false,
    }),

    methods: {
        open() {
            this.showModal = true;
            this.bookableHoursBeforeDay = this.category.bookable_hours_before_day;
            this.maxConcurrentBookingPerDay = this.category.max_concurrent_booking_per_day;
        },
        store() {
            this.loading = true;
            this.$http.put(`/admin/bookable_categories/${this.category.id}`, {
                bookable_hours_before_day: this.bookableHoursBeforeDay,
                max_concurrent_booking_per_day: this.maxConcurrentBookingPerDay,
            })
                .then(() => {
                    this.$root.$emit('alert', 'Gespeichert.');
                    this.loading = false;
                })
                .catch(error => {
                    this.loading = false;
                    this.$root.$emit('error', error);
                });
        },
    },
}
</script>

<style scoped>

</style>
